import api from './api';

const BASE = '/surveys';
const MY = '/my/surveys';

export const SURVEY_STATUSES = [
  { value: 'draft', label: 'Draft', color: 'default' },
  { value: 'active', label: 'Active', color: 'success' },
  { value: 'inactive', label: 'Inactive', color: 'warning' },
  { value: 'closed', label: 'Closed', color: 'default' },
];

export const QUESTION_TYPES = [
  { value: 'text', label: 'Short text' },
  { value: 'textarea', label: 'Paragraph' },
  { value: 'single_choice', label: 'Single choice' },
  { value: 'multi_choice', label: 'Multiple choice' },
  { value: 'yes_no', label: 'Yes / No' },
  { value: 'rating', label: 'Rating' },
  { value: 'dropdown', label: 'Dropdown' },
  { value: 'date', label: 'Date' },
  { value: 'file', label: 'File upload' },
];

export const CONDITION_OPERATORS = [
  { value: 'equals', label: 'is' },
  { value: 'not_equals', label: 'is not' },
  { value: 'in', label: 'is any of' },
  { value: 'not_in', label: 'is none of' },
  { value: 'contains', label: 'includes' },
  { value: 'gt', label: 'is greater than' },
  { value: 'gte', label: 'is at least' },
  { value: 'lt', label: 'is less than' },
  { value: 'lte', label: 'is at most' },
  { value: 'between', label: 'is between' },
  { value: 'answered', label: 'is answered' },
  { value: 'not_answered', label: 'is not answered' },
];

export const usesOptions = (type) =>
  ['single_choice', 'multi_choice', 'yes_no', 'dropdown'].includes(type);

export const operatorNeedsValue = (op) => !['answered', 'not_answered'].includes(op);

// ---- Admin: survey CRUD + lifecycle -----------------------------------------
export const fetchSurveys = (params = {}) => api.get(BASE, { params }).then((r) => r.data);
export const fetchSurvey = (id) => api.get(`${BASE}/${id}`).then((r) => r.data?.data || r.data);
export const createSurvey = (payload) => api.post(BASE, payload).then((r) => r.data?.data || r.data);
export const updateSurvey = (id, payload) => api.put(`${BASE}/${id}`, payload).then((r) => r.data?.data || r.data);
export const deleteSurvey = (id) => api.delete(`${BASE}/${id}`).then((r) => r.data);
export const validateSurvey = (id) => api.post(`${BASE}/${id}/validate`).then((r) => r.data);
export const activateSurvey = (id) => api.post(`${BASE}/${id}/activate`).then((r) => r.data);
export const deactivateSurvey = (id) => api.post(`${BASE}/${id}/deactivate`).then((r) => r.data);
export const closeSurvey = (id) => api.post(`${BASE}/${id}/close`).then((r) => r.data);
export const duplicateSurvey = (id) => api.post(`${BASE}/${id}/duplicate`).then((r) => r.data?.data || r.data);

// ---- Builder: questions ------------------------------------------------------
export const createQuestion = (surveyId, payload) =>
  api.post(`${BASE}/${surveyId}/questions`, payload).then((r) => r.data?.data || r.data);
export const updateQuestion = (surveyId, qId, payload) =>
  api.put(`${BASE}/${surveyId}/questions/${qId}`, payload).then((r) => r.data?.data || r.data);
export const deleteQuestion = (surveyId, qId) =>
  api.delete(`${BASE}/${surveyId}/questions/${qId}`).then((r) => r.data);
export const reorderQuestions = (surveyId, order) =>
  api.post(`${BASE}/${surveyId}/questions/reorder`, { order }).then((r) => r.data);

// ---- Results -----------------------------------------------------------------
export const fetchResponses = (id, params = {}) => api.get(`${BASE}/${id}/responses`, { params }).then((r) => r.data);
export const fetchResponse = (id, responseId) =>
  api.get(`${BASE}/${id}/responses/${responseId}`).then((r) => r.data?.data || r.data);
export const fetchAnalytics = (id, params = {}) => api.get(`${BASE}/${id}/analytics`, { params }).then((r) => r.data);
export const grantAccess = (id, payload) => api.post(`${BASE}/${id}/grants`, payload).then((r) => r.data);

export async function downloadResultsCsv(id) {
  const res = await api.get(`${BASE}/${id}/export`, { responseType: 'blob' });
  const blob = new Blob([res.data], { type: 'text/csv' });
  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.href = url;
  link.download = `survey-${id}-responses.csv`;
  document.body.appendChild(link);
  link.click();
  link.remove();
  URL.revokeObjectURL(url);
}

// ---- Employee runner ---------------------------------------------------------
export const fetchMySurveys = () => api.get(MY).then((r) => r.data?.data || r.data);
export const fetchMySurvey = (id) => api.get(`${MY}/${id}`).then((r) => r.data);
export const saveProgress = (id, answers) => api.post(`${MY}/${id}/save`, { answers }).then((r) => r.data);
export const submitSurvey = (id, answers) => api.post(`${MY}/${id}/submit`, { answers }).then((r) => r.data);

export const uploadSurveyFile = (id, file) => {
  const fd = new FormData();
  fd.append('file', file);
  return api.post(`${MY}/${id}/files`, fd, { headers: { 'Content-Type': 'multipart/form-data' } }).then((r) => r.data);
};
